module.exports = __webpack_public_path__ + "static/media/Boman_Qujan_2026_PDF.11235332.pdf";